/**
 * Sub-navigation between the dashboard's seven pages (brief §teacher). Plain
 * `NavLink`s rather than the controlled `Tabs` kit component — these are real
 * routes, not panels toggled in place, so the browser's own tab/keyboard
 * navigation and back-button behaviour apply for free.
 */
import clsx from "clsx";
import { NavLink } from "react-router";
import { useT } from "@client/i18n";

const ITEMS: { to: string; end?: boolean; labelKey: string }[] = [
  { to: "/teacher", end: true, labelKey: "teacher.tabs.overview" },
  { to: "/teacher/students", labelKey: "teacher.tabs.students" },
  { to: "/teacher/questions", labelKey: "teacher.tabs.questions" },
  { to: "/teacher/exams", labelKey: "teacher.tabs.exams" },
  { to: "/teacher/reports", labelKey: "teacher.tabs.reports" },
  { to: "/teacher/prep", labelKey: "teacher.tabs.prep" },
  { to: "/teacher/releases", labelKey: "teacher.tabs.releases" },
];

export function TeacherNav() {
  const t = useT();
  return (
    <nav
      aria-label={t("teacher.nav")}
      className="mb-6 flex flex-wrap gap-1 border-b border-ink-200 dark:border-ink-800"
    >
      {ITEMS.map((item) => (
        <NavLink
          key={item.to}
          to={item.to}
          end={item.end}
          className={({ isActive }) =>
            clsx(
              "-mb-px whitespace-nowrap rounded-t-lg border-b-2 px-3 py-2 text-sm font-medium transition-colors",
              isActive
                ? "border-accent-600 text-accent-800 dark:text-accent-200"
                : "border-transparent text-ink-600 hover:text-ink-900 dark:text-ink-400 dark:hover:text-ink-100",
            )
          }
        >
          {t(item.labelKey)}
        </NavLink>
      ))}
    </nav>
  );
}

export default TeacherNav;
